namespace GeniuzPOS.Lookups {
    export interface VwPluLookupSetItemRow {
        PluCode?: string;
        PluDesc?: string;
        PluFullCode?: string;
        PluShortDesc?: string;
        SellUnit?: string;
        SellUnitPrice1?: number;
    }

    export namespace VwPluLookupSetItemRow {
        export const idProperty = 'PluCode';
        export const nameProperty = 'PluFullCode';
        export const localTextPrefix = 'Lookups.VwPluLookupSetItem';
        export const lookupKey = 'Lookups.VwPluLookupSetItem';

        export function getLookup(): Q.Lookup<VwPluLookupSetItemRow> {
            return Q.getLookup<VwPluLookupSetItemRow>('Lookups.VwPluLookupSetItem');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            PluFullCode = "PluFullCode",
            PluShortDesc = "PluShortDesc",
            SellUnit = "SellUnit",
            SellUnitPrice1 = "SellUnitPrice1"
        }
    }
}
